<template>
  <div class="row">
    <div class="col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-body p-10">
          <ul class="settings-tabs ps-0 mb-0 list-unstyled">
            <li>
              <router-link
                to="/account-settings"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              >
                Account Settings
              </router-link>
            </li>

            

            <li>
              <router-link
                to="/settings-statuts"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Status
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-type-clients"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Types des clients
              </router-link>
            </li>
            <li>
              <router-link
                to="/settings-banks"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Liste des banques
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-social-links"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Social Link
              </router-link>
            </li>

            <!-- <li>
              <router-link
                to="/settings-privacy-policy"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              >
                Privacy Policy
              </router-link>
            </li> -->
          </ul>
        </div>
      </div>
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card"
      >
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-12 mb-4">
                <div class="d-flex align-items-center gap-3">
                  <!-- User Image -->
                  <div class="image position-relative">
                    <img
                      :src="logoPreview || require('@/assets/images/NoImage.png')"
                      class="rounded-circle"
                      width="85"
                      height="85"
                      
                    />
                  </div>

                  <!-- File Input -->
                  <div class="form-group mb-0">
                    <label class="d-block text-black fw-semibold mb-10">
                      Upload Your Profile Picture
                    </label>
                    <input
                      class="form-control fs-15 text-black shadow-none"
                      type="file"
                      id="formFile"
                      @change="onFileChangeLogo"
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Nom de la société
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. Adam"
                    v-model="settingData.name"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    web site
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. Smith"
                    v-model="settingData.website"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Email Address
                  </label>
                  <input
                    type="email"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. adam127704@gmail.com"
                    v-model="settingData.email"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Phone No
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. +001 321 4567"
                    v-model="settingData.phone"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Ville
                  </label>
                  <select
                    class="form-select shadow-none fw-semibold rounded-0"
                    v-model="settingData.siege"
                  >
                    <option
                      v-for="option in cities"
                      :key="option.id"
                      :value="option.name"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Select Devis
                  </label>
                  <select class="form-select shadow-none fw-semibold rounded-0">
                    <option value="MAD">MAD</option>
                    <option value="EUR">EUR</option>
                    <option value="USD">USD</option>
                  </select>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Address
                  </label>
                  <textarea
                    class="form-control shadow-none fs-md-15 text-black"
                    v-model="settingData.adresse"
                  ></textarea>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Les conditions générales
                  </label>
                  <textarea
                    rows="15"
                    class="form-control shadow-none fs-md-15 text-black"
                    v-model="settingData.conditions"
                  ></textarea>
                </div>
              </div>
              <div class="col-md-12">
                <div class="d-flex align-items-center justify-content-between">
                  <button
                    class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                    type="submit"
                  >
                    Save Changes
                  </button>
                  <!-- <button
                    type="button"
                    class="bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                  >
                    <i
                      class="flaticon-delete lh-1 me-1 position-relative top-2"
                    ></i>
                    <span class="position-relative">Cancel</span>
                  </button> -->
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import BlotFormatter from "quill-blot-formatter";
import ImageUploader from "quill-image-uploader";
import axios from "axios";
import api from "@/utils/axios";
// import Select2 from "@/components/Select2.vue";
import { useAppToast } from "@/composables/useAppToast";

export default defineComponent({
  name: "AccountSettings",
  //  components :{ Select2 },

  setup: () => {
    const { showToast } = useAppToast();

    const modules = {
      module: BlotFormatter,
      ImageUploader,
      options: {
        upload: (file: string | Blob) => {
          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("image", file);

            axios
              .post("/upload-image", formData)
              .then((res: { data: { url: unknown } }) => {
                console.log(res);
                resolve(res.data.url);
              })
              .catch((err: unknown) => {
                reject("Upload failed");
                console.error("Error:", err);
              });
          });
        },
      },
    };

    const logoPreview = ref<string | null>(null);
    const logoFile = ref<File | null>(null);
    const settingData = reactive<Record<string, any>>({});
    const cities = ref<any[] | null>(null);

    onMounted(async () => {
      try {
        const response = await api.get(`/api/auth/general_list`);
        Object.assign(settingData, response.data);
        if (response.data.logo) {
          logoPreview.value = response.data.logo;
        }
      } catch (error) {
        console.error("Error fetching user account:", error);
      }

      try {
        const response = await api.get(`/api/auth/citiesList`);
        cities.value = response.data; // ✅ assign to .value
        // console.log("Fetched cities:", cities.value);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    });

    const onFileChangeLogo = (event: Event) => {
      const input = event.target as HTMLInputElement;
      if (input.files && input.files[0]) {
        const file = input.files[0];
        logoFile.value = file;
        logoPreview.value = URL.createObjectURL(file);
      }
    };

    // Submit form
    async function submitForm() {
      try {
        const formData = new FormData();
        formData.append("name", settingData.name);
        formData.append("website", settingData.website);
        formData.append("email", settingData.email);
        formData.append("phone", settingData.phone);
        formData.append("siege", settingData.siege);
        formData.append("devis", settingData.currency);
        formData.append("adresse", settingData.adresse);
        formData.append("conditions", settingData.conditions);

        if (logoFile.value) {
          formData.append("logo", logoFile.value);
        }

        const response = await api.post("/api/auth/general_add", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.data.success) {
          showToast("Settings saved successfully!", "success");
        } else {
          showToast("Error: " + response.data.message, "error");
        }
      } catch (error) {
        console.error(error);
        showToast("An error occurred while saving settings.", "error");
      }
    }

    return {
      modules,
      logoPreview,
      cities,
      settingData,
      onFileChangeLogo,
      submitForm,
    };
  },
});
</script>